<script lang="ts">
	import { onMount } from 'svelte'
	import type { EvaluationResult } from '../../types/analytical'
	import Tooltip from '$lib/atoms/Tooltip.svelte'
	import { TooltipPlacements } from '$types/enums'
	import { t } from '$i18n/i18n'
	import Button from '$lib/atoms/Button.svelte'
	import Tooltip_v5 from '$lib/atoms/Tooltip_v5.svelte'

	export let evaluationResult: EvaluationResult

	let id = evaluationResult.name
	let label: string = 'Kopieren'

	let tooltip: Tooltip

	function copyTextToClipboard() {
		const el = document.getElementById('worst-value-string-' + id)
		if (!el) return
		const text = el.innerText.replace(/\u2002/g, ' ')
		navigator.clipboard.writeText(text).then(() => {
			label = 'Kopiert!'
			setTimeout(() => (label = 'Kopieren'), 1500)
		})
	}

	onMount(() => {
		const handleScroll = () => {
			if (tooltip) {
				tooltip?.hide?.()
			}
		}

		document
			.querySelector('.analytic-table')
			?.addEventListener('scroll', handleScroll, { passive: true })
	})
</script>

<Tooltip_v5
	bind:ref={tooltip}
	zIndex={99999999}
	placementTtip={TooltipPlacements.BOTTOM_END}
	offsetTtip={[-50, 10]}
	maxWidthTtip={384}
	delayTtip={[0, 0]}
>
	{#each (evaluationResult.worstValues ?? []).slice(0, 3) as wv, i (wv.name + i)}
		<div class="analytical-row-highest-values">
			<h6>{wv.name}:</h6>
			<span>
				{wv.value}{wv.unit ??
					''}{#if i === 2 && evaluationResult.worstValues?.length > 3}&hellip;{:else};{/if}
			</span>
		</div>
	{/each}
	{#snippet content()}
		<div class="tooltip-analytical-content" slot="content">
			<div class="tooltip-analytical-scrollable scrollable">
				<h6>{$t('Analytics.maxValue')}</h6>
				<div id="worst-value-string-{id}">
					{#each evaluationResult.worstValues ?? [] as wv, i (wv.name + i)}
						<h6 style="display: inline-block">{wv.name}:&ensp;</h6>
						<span>{wv.value}{wv.unit ?? ''}</span>;&ensp;
					{/each}
				</div>
			</div>
			<Button variant="secondary" onclick={copyTextToClipboard} width="--width: auto;">
				{label}
			</Button>
		</div>
	{/snippet}
</Tooltip_v5>

<style lang="scss">
	@use '$styles/global';

	.tooltip-analytical-content {
		@include global.flex-col(0.75rem, $alignment: flex-start);

		background: white;
		width: 100%;
		max-width: 22rem;
	}

	.tooltip-analytical-scrollable {
		max-height: 256px;
		overflow-y: auto;
		padding-right: 10px;

		& h6 {
			line-height: 1.125rem;
			margin: 0;
		}

		& > h6:first-child {
			padding-bottom: 0.69rem;
		}
	}

	.analytical-row-highest-values {
		margin-bottom: 0.125rem;
		max-width: 150px;

		& h6 {
			padding: 0;
			margin: 0;
			white-space: normal;
			overflow-wrap: break-word;
			min-width: 0;
			display: inline;
		}

		& span {
			display: inline;
		}
	}
</style>
